import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import { equals, isNil, map, filter, includes, length, append, slice } from "ramda";
import { useEffect, useRef, useState } from "react";
function KeepAlive(param) {
    let { activeName, children, exclude, include, maxLen = 10 } = param;
    const containerRef = useRef(null);
    const [cacheReactNodes, setCacheReactNodes] = useState([]);
    useEffect(()=>{
        if (isNil(activeName)) {
            return;
        }
        setCacheReactNodes((cacheReactNodes)=>{
            // 缓存超过上限的
            if (length(cacheReactNodes) >= maxLen) {
                cacheReactNodes = slice(1, length(cacheReactNodes), cacheReactNodes);
            }
            // 添加
            const cacheReactNode = cacheReactNodes.find((res)=>equals(res.name, activeName));
            if (isNil(cacheReactNode)) {
                cacheReactNodes = append({
                    name: activeName,
                    ele: children
                }, cacheReactNodes);
            } else {
                cacheReactNodes = map((res)=>{
                    return equals(res.name, activeName) ? {
                        ...res,
                        ele: children
                    } : res;
                }, cacheReactNodes);
            }
            return isNil(exclude) && isNil(include) ? cacheReactNodes : filter((param)=>{
                let { name } = param;
                if (exclude && includes(name, exclude)) {
                    return false;
                }
                if (include) {
                    return includes(name, include);
                }
                return true;
            }, cacheReactNodes);
        });
    }, [
        children,
        activeName,
        exclude,
        maxLen,
        include
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: containerRef,
                className: "keep-alive"
            }),
            map((param)=>{
                let { name, ele } = param;
                return /*#__PURE__*/ _jsx(Component, {
                    active: equals(name, activeName),
                    renderDiv: containerRef,
                    name: name,
                    children: ele
                }, name);
            }, cacheReactNodes)
        ]
    });
}
export default KeepAlive;
function Component(param) {
    let { active, children, name, renderDiv } = param;
    const [targetElement] = useState(()=>document.createElement("div"));
    const activatedRef = useRef(false);
    activatedRef.current = activatedRef.current || active;
    useEffect(()=>{
        if (active) {
            var _renderDiv_current;
            (_renderDiv_current = renderDiv.current) === null || _renderDiv_current === void 0 ? void 0 : _renderDiv_current.appendChild(targetElement);
        } else {
            try {
                var _renderDiv_current1;
                (_renderDiv_current1 = renderDiv.current) === null || _renderDiv_current1 === void 0 ? void 0 : _renderDiv_current1.removeChild(targetElement);
            } catch (e) {}
        }
    }, [
        active,
        renderDiv,
        targetElement
    ]);
    useEffect(()=>{
        targetElement.setAttribute("id", name);
    }, [
        name,
        targetElement
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: activatedRef.current && /*#__PURE__*/ ReactDOM.createPortal(children, targetElement)
    });
}
